import { PublicClientApplication, Configuration } from "@azure/msal-browser";
import Constants from "../../appConfig/Constants";

// Utility function to generate the MSAL configuration dynamically based on clientId
export const createMsalConfig = (clientId: string): Configuration => ({
  auth: {
    clientId: clientId, 
    authority: Constants.AUTHORITY, 
    redirectUri: Constants.REDIRECT_URL,
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level: any, message: any, containsPii: any) => {
        if (containsPii) {
          return;
        }
      },
    },
  },
});

// Example of creating an instance with clientId
export const getMsalInstance = (clientId: string) => {
    const msalConfig = createMsalConfig(clientId);
    return new PublicClientApplication(msalConfig);
};